import { fromJS } from 'immutable';
import { normalizeEntities } from 'helpers/utilHelpers';

import { LOAD_RBAC_ITEMS_SUCCESS, LOAD_USER_PERMISSIONS_SUCCESS, SIGNOUT_USER_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  items: {},
  userPermissions: {},
});

const rbacReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_RBAC_ITEMS_SUCCESS:
      return state.set('items', normalizeEntities(action.items, 'name'));
    case LOAD_USER_PERMISSIONS_SUCCESS:
      return state.set('userPermissions', normalizeEntities(action.permissions.items, 'name'));
    case SIGNOUT_USER_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default rbacReducer;
